import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";
import { Team } from "shared/interfaces/Team";
import { fetchLoggedUserTeams } from "shared/service/StrmService";
import FormFinish from "./FormFinish";
import FormMember from "./FormMembers";
import FormName from "./FormName";

const TeamStart: React.FC<RouteComponentProps> = () => {
  const [team, setTeam] = useState<Team>();
  const [form, setForm] = useState<string>("name");

  useEffect(() => {
    const getTeam = async () => {
      const response: any = await fetchLoggedUserTeams();
      setTeam(response);
    };

    getTeam();
  }, []);

  return (
    <div className="radar">
      <Row style={{ padding: "72px 0" }}>
        <Col xs={12}>
          {form === "name" && (
            <FormName team={team} onNext={() => setForm("members")} />
          )}

          {form === "members" && (
            <FormMember team={team} onNext={() => setForm("finish")} />
          )}

          {form === "finish" && <FormFinish />}
        </Col>
      </Row>
    </div>
  );
};

export default TeamStart;
